//This is for the API
//API_KEY from tmdb website we created new user and got our unique key from there
export const API_KEY = "ab324b374264dafb770cc29db02e0f34";

//tmdb website url
export const TMBD_BASE_URL = "https://api.themoviedb.org/3"